export default err => {
  throw err
}
